import { render, staticRenderFns } from "./ContentBlockTiktokOEmbed.vue?vue&type=template&id=a0ee25a2&"
import script from "./ContentBlockTiktokOEmbed.vue?vue&type=script&lang=js&"
export * from "./ContentBlockTiktokOEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports